import { gql } from 'graphql-request';
import {
  ItemCategoryCreatedAt,
  ItemCategoryID,
  ItemCategoryName,
  ItemCategoryNanoID,
  ItemCategoryUUID,
  ItemCategoryUpdatedAt
} from '../itemCategoriesTypes';
import { UserID } from '../../users/usersTypes';

export interface FetchCacheItemCategoriesItemCategoryType {
  id: ItemCategoryID;
  uuid: ItemCategoryUUID;
  nanoId: ItemCategoryNanoID;
  createdAt: ItemCategoryCreatedAt;
  updatedAt: ItemCategoryUpdatedAt;
  name: ItemCategoryName;
  userId: UserID;
}

export const FETCH_CACHE_ITEM_CATEGORIES_QUERY = gql`
  query CacheItemsCategories(
    $filters: ItemCategoriesFilters
    $limit: Int
    $offset: Int
    $sort: [ItemCategoriesSortEnum!]
    $source: String
    $trackTotalHits: Boolean
  ) {
    itemCategories(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        id
        uuid
        nanoId
        createdAt
        updatedAt
        name
        userId
      }
      paginationInfo {
        nextPage
        totalCount
      }
      sql
    }
  }
`;
